import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from '../../../../components/navigation';
import { ToastType } from '../../../core';
import { addToast } from '../../../core/actions';
import { fetch } from '../../actions';
import { selectSsoServices } from '../../selectors';
import { AdminSsoTable } from '../AdminSsoTable';
export const AdminSsoServiceList = () => {
    const ssoServices = useSelector(selectSsoServices);
    const dispatch = useDispatch();
    useEffect(() => {
        const fetchData = async () => {
            try {
                await dispatch(fetch());
            }
            catch (e) {
                dispatch(addToast(ToastType.error, e.message));
            }
        };
        void fetchData();
    }, [dispatch]);
    return (<>
      <header className="settings-header">
        <h2 className="header-title">Manage SSO Services</h2>
        <p className="header-description">
          Browse, edit and add new SSO services.
        </p>
      </header>

      {ssoServices.length > 0 && <AdminSsoTable ssoServices={ssoServices}/>}

      <footer className="settings-footer">
        <Link to={'/account/admin/sso-services/create'} className="button button--stroke">
          Create new
        </Link>
      </footer>
    </>);
};
